<style scoped>
.navbar {
  padding-top: 0;
  padding-bottom: 0;
}

ul.shop-toggles li a {
  font-weight: initial !important;
}

ul.collapsible li a.collapsible-header {
  padding: 0 32px;
}

.sidenav .user-view {
  background-color: rgba(0, 0, 0, 0.5);
}

/* .sidenav {
      z-index: 4
  } */

.background {
  background-repeat: no-repeat;
  background-size: cover;
}

nav {
  overflow: hidden;
}

.circle {
  background-color: #ffffff;
}

@media only screen and (max-width: 992px) {
  nav {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media only screen and (min-width: 992px) {
  nav {
    padding-left: 332px;
    padding-right: 332px;
  }
}

a.brand-logo {
  font-weight: 200;
}

a.brand-logo span {
  font-weight: 500;
}
</style>

<template lang="pug">
div
  nav.navbar.dark
    .nav-wrapper
      a.brand-logo.ell(href='#') Inom.ph&nbsp;
        span Supplier
      a.button-collapse.sidenav-trigger(href='#', data-target='slide-out')
        i.material-icons menu
  ul#slide-out.secondary-background.sidenav.sidenav-fixed
    li
      .user-view
        .background(
          :style='{ backgroundImage: "url(" + imageUrlBanner + ")" }'
        )
          //- img.responsive-img(:src="imageUrl")
        a(href='#!user')
          img.circle(
            v-if='!imageUrlThumbnail',
            src='../assets/avatar-placeholder.png'
          )
          img.circle(v-if='imageUrlThumbnail', :src='imageUrlThumbnail')
        a(href='#!name')
          span.white-text.name {{ user.displayName }}
        a(href='#!email')
          span.white-text.email {{ user.email }}
    li(v-bind:class='activeRoute === "orders" ? "active" : ""')
      router-link.sidenav-close(:to='"/orders"') Orders
    li(v-bind:class='activeRoute === "products-list" ? "active" : ""')
      router-link.sidenav-close(:to='"/products"') Products
    li(v-bind:class='activeRoute === "discount" ? "active" : ""')
      router-link.sidenav-close(:to='"/discount"') Discount
    li(v-bind:class='activeRoute === "inventory-list" ? "active" : ""')
      router-link.sidenav-close(:to='"/inventories"') Inventories
    li(v-bind:class='activeRoute === "order-history" ? "active" : ""')
      router-link.sidenav-close(:to='"/order-history"') Order History
    //- li
    //-   .divider
    //- li
    //-   router-link.sidenav-close(:to='{name: "shop-list"}') Shops
    //-   app-shop-toggles
    //- li.divider
    li(v-bind:class='activeRoute === "settings" ? "active" : ""')
      router-link.sidenav-close(:to='"/settings"') Settings
    li(v-bind:class='activeRoute === "report" ? "active" : ""')
      router-link.sidenav-close(:to='"/report"') Report
    //- li(v-bind:class='activeRoute === "user" ? "active" : ""')
    //-   router-link.sidenav-close(:to='"/user"') Personnel Management
    li
      a(href='#', v-on:click='confirmLogout') Log out
  v-dialog(v-model='dialogLogout', max-width='290', :persistent='true')
    v-card(v-if='!showLoading')
      v-card-text
        | Are you sure you want to logout?
      v-card-actions
        v-spacer
        v-btn(color='black', flat='flat', @click='dialogLogout = false')
          | Cancel
        v-btn(color='#b03236', flat='flat', @click='logout')
          | Yes
    v-card(v-if='showLoading')
      v-card-text
        | Please wait...
        v-progress-linear(:size='70', color='#b03236', indeterminate)
</template>
<script>
import AppShopToggles from '@/components/app-shop-toggles'

export default {
  data () {
    return {
      currentRoute: '',
      dialogLogout: false,
      showLoading: false
    }
  },
  computed: {
    imageUrlBanner () {
      if (!this.$store.state.profile.supplier) {
        return
      }
      return this.$store.state.profile.supplier.photos.big
    },
    imageUrlThumbnail () {
      if (!this.$store.state.profile.supplier) {
        return
      }
      return this.$store.state.profile.supplier.photos.small
    },
    activeRoute () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currentRoute = this.$router.currentRoute.name
      return this.currentRoute
    },
    user () {
      return this.$store.state.auth.user || {}
    }
  },
  mounted () {
    var elems = document.querySelectorAll('.sidenav')
    this.$M.Sidenav.init(elems)
    this.$M.Collapsible.init(this.$refs.shopCollapse)
  },
  watch: {
    $route (to, from) {
      this.currentRoute = to.name
    }
  },
  methods: {
    confirmLogout () {
      this.dialogLogout = true
    },

    logout () {
      this.showLoading = true
      return this.$store.dispatch('auth/logout').then(() => {
        this.dialogLogout = false
        this.showLoading = false
        this.$router.replace('login')
      })
    }
  },
  components: {
    AppShopToggles
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-side-nav.vue